import { Backdrop, CircularProgress, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import '../../../scss/pages/Employee helpdesk/Open Request/openRequest.scss';
import TagOpenReq from '../../../asset/svg/TagOpenReq.svg';
import Chat from '../../../asset/svg/Chat.svg';
import EllipseDot from '../../../asset/svg/EllipseDot.svg';
import Calendar from '../../../asset/svg/Calendar-Icon.svg'
import { useNavigate } from 'react-router';
import { EMPLOYEE_HELPDESK_COMMENTS, RAISE_REQUEST_PATH } from '../../../utils/Constants';
import { useDispatch, useSelector } from 'react-redux';
import { GET_TICKET_DATA } from '../../../sagas/type';
import moment from 'moment';

function OpenRequest() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { EmployeeTickets } = useSelector(mapStateToProps);
    const [loader, setLoader] = useState(false)
    const handleRaiseRequest = () => {
        navigate(RAISE_REQUEST_PATH)
    }
    const handleCheckComments = (ticketNo) => {
        navigate(EMPLOYEE_HELPDESK_COMMENTS, { state: { ticketNo: ticketNo } })
        dispatch({
            type: GET_TICKET_DATA,
            payload: ticketNo,
        })
    }

    return (
        <>
            <div className='Open-request-container'>
                <div className='Open-request-container_Card-Head'>
                    {EmployeeTickets && EmployeeTickets?.length > 0 ? <>
                        {EmployeeTickets?.filter(item => item?.status === 'NEW' || item?.status === 'INPROGRESS')?.sort((a, b) => {
                            const lastReplyA = a?.replies[a?.replies?.length - 1];
                            const lastReplyB = b?.replies[b?.replies?.length - 1];

                            const dateA = new Date(lastReplyA ? lastReplyA?.updatedDate || lastReplyA?.createdDate : a?.updatedDate || a?.createdDate);
                            const dateB = new Date(lastReplyB ? lastReplyB?.updatedDate || lastReplyB?.createdDate : b?.updatedDate || b?.createdDate);

                            return dateB - dateA;
                        })?.map((request) => {
                            return (
                                <Box key={request?.ticketNo} sx={{ marginTop: "10px" }} onClick={() => handleCheckComments(request?.ticketNo)}>
                                    <Box className='Open-request-container_Card-Head_Data'>
                                        <div className='Open-request-container_Card-Head_Data_Child'>
                                            <div className='Open-request-container_Card-Head_Data_Child_Child-sub'>
                                                <div className='Open-request-container_Card-Head_Data_Child_Child-sub_Tag-status'>
                                                    <div className='Open-request-container_Card-Head_Data_Child_Child-sub_Tag-status_Icon-tag'>
                                                        <img src={TagOpenReq} width='20px' height='20px' />
                                                        <Typography sx={{ fontSize: "10px", fontWeight: 500, fontFamily: "'Noto Sans', sans-serif", color: "rgba(255, 255, 255, 0.40)" }}>{request?.ticketNo}</Typography>
                                                    </div>
                                                    {request?.status == 'NEW' && <div className='Open-request-container_Card-Head_Data_Child_Child-sub_Tag-status_New-sts'>
                                                        <Typography sx={{ color: "#EAA439", fontSize: "10px", fontWeight: 500, fontFamily: "'Noto Sans', sans-serif" }}>New</Typography>
                                                    </div>}
                                                    {request?.status == 'INPROGRESS' && <div className='Open-request-container_Card-Head_Data_Child_Child-sub_Tag-status_Inprogress-sts'>
                                                        <Typography sx={{ color: "#12B9DD", fontSize: "10px", fontWeight: 500, fontFamily: "'Noto Sans', sans-serif" }}>In progress</Typography>
                                                    </div>}
                                                </div>
                                                {request?.replies?.length > 0 && <div className='Open-request-container_Card-Head_Data_Child_Child-sub_Reply'>
                                                    <img src={Chat} width='15px' height='15px' />
                                                    <Typography sx={{ color: "#FFF", fontSize: "10px", fontWeight: 500, fontFamily: "'Noto Sans', sans-serif", whiteSpace: "nowrap" }}>{`${request?.replies?.length + " " + "Reply"}`}</Typography>
                                                </div>}
                                            </div>
                                            <div className='Open-request-container_Card-Head_Data_Child_Child-sub2'>
                                                <div className='Open-request-container_Card-Head_Data_Child_Child-sub2_Category'>
                                                    <Typography sx={{ color: "#FFF", fontSize: "14px", fontWeight: 600, fontFamily: "'Noto Sans', sans-serif", whiteSpace: "nowrap" }}>{request?.subCategoryVo?.name}</Typography>
                                                    <img src={EllipseDot} width='7px' height='7px' />
                                                    <Typography sx={{ color: "rgba(255, 255, 255, 0.40)", fontSize: "12px", fontWeight: 400, fontFamily: "'Noto Sans', sans-serif", whiteSpace: "nowrap" }}>{request?.subCategoryVo?.category}</Typography>
                                                </div>
                                                <Typography sx={{ color: "rgba(255, 255, 255, 0.70)", fontSize: "12px", fontWeight: 400, fontFamily: "'Noto Sans', sans-serif", whiteSpace: "nowrap" }}>{request?.description}</Typography>
                                                <div className='Open-request-container_Card-Head_Data_Child_Child-sub2_Date-Icon'>
                                                    <img src={Calendar} width='10px' height='10px' />
                                                    <Typography sx={{ color: "#FFF", fontSize: "10px", fontWeight: 400, fontFamily: "'Noto Sans', sans-serif", whiteSpace: "nowrap", opacity: 0.4 }}>{moment(request?.createdDate).format("DD MMM YYYY, HH:mm")}</Typography>
                                                </div>
                                            </div>
                                        </div>
                                    </Box>
                                </Box>
                            )
                        })}
                    </> :
                        <div className='Open-request-container_No-open-requests'>
                            <div className='Open-request-container_No-open-requests_Content'>
                                <div className='Open-request-container_No-open-requests_Content_Text'>
                                    <Typography className='Open-request-container_No-open-requests_Content_Text_Text-content'>No Open Requests</Typography>
                                </div>
                                <div className='Open-request-container_No-open-requests_Content_Button'>
                                    <button className='Open-request-container_No-open-requests_Content_Button_active-button' onClick={handleRaiseRequest}>Raise a Request</button>
                                </div>
                            </div>
                        </div>}
                </div>
            </div>
            {EmployeeTickets && EmployeeTickets.length > 0 && <div className='Open-request-container_Button'>
                <button className='Open-request-container_Button_active-button' onClick={handleRaiseRequest}>+ New Request</button>
            </div>}

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loader}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    )
}
const mapStateToProps = (state) => {
    return {
        EmployeeTickets: state?.employeeHelpdesk?.GetEmployeeTickets,
    }
}
export default OpenRequest